import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";

//Material UI components
import { InputBase, Typography, AppBar, Container, Toolbar, ListItem, ListItemText, ListItemAvatar, IconButton, List } from "@material-ui/core";

//Material UI icons
import { Search, ArrowForwardIos, HighlightOffRounded, CheckCircleOutlineRounded } from "@material-ui/icons";

import axios from "axios";

export class StaffListView extends Component {
    static displayName = StaffListView.name;

    constructor(props) {
        super(props);
        this.state = {
            employees: [],
            employeesOrginalFetch: [],
            loading: true
        };
    }

    componentDidMount = () => {
        this.fetchEmployees();
    };

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    filterList = event => {
        //mabe do some work with cache and do fetch
        var searchInput = event.currentTarget.value.toLowerCase().trim();

        if (searchInput === "") {
            this.setState({ employees: this.state.employeesOrginalFetch });
        } else {
            var filteredData = this.state.employeesOrginalFetch.filter(function(obj) {
                return obj.nationalRegistryId.toLowerCase().startsWith(searchInput);
            });
            this.setState({ employees: filteredData });
        }
    };

    render() {
        const classes = this.props;
        const primaryText = {
            fontSize: "34px"
        };

        const secondaryText = {
            fontSize: "28px"
        };

        let employeeList = this.state.loading ? (
            <p>
                <em>Loading...</em>
            </p>
        ) : (
            <List>
                {this.state.employees.map(employee => {
                    return (
                        <ListItem
                            button
                            //style={style}
                            key={employee.id}
                            component={Link}
                            to={"/timeclock/" + employee.id + "/" + employee.name}
                        >
                            <ListItemAvatar>
                                {employee.isCheckedIn ? (
                                    <CheckCircleOutlineRounded fontSize="large" style={{ color: "#28a745" }} />
                                ) : (
                                    <HighlightOffRounded fontSize="large" style={{ color: "#dc3545" }} />
                                )}
                            </ListItemAvatar>

                            <ListItemText
                                primary={employee.name}
                                primaryTypographyProps={{ style: primaryText }}
                                secondary={employee.nationalRegistryId != null ? employee.nationalRegistryId.slice(0, 6) : "-"}
                                secondaryTypographyProps={{ style: secondaryText }}
                            />
                            <div>
                                <IconButton edge="end" aria-label="delete">
                                    <ArrowForwardIos />
                                </IconButton>
                            </div>
                        </ListItem>
                    );
                })}
            </List>
        );

        return (
            <div>
                <AppBar style={{ backgroundColor: "rgb(141,198,63)" }}>
                    <Toolbar variant="regular" style={{ height: "95px" }}>
                        <Typography variant="h4" style={{ flexGrow: 1 }}>
                            Time Registration
                        </Typography>
                        <div>
                            <Search style={{ fontSize: "2.5rem" }} />
                            <InputBase
                                placeholder="Search by kt"
                                type="number"
                                classes={{
                                    root: classes.inputRoot,
                                    input: classes.inputInput
                                }}
                                style={{ fontSize: "2rem", color: "white" }}
                                inputProps={{ "aria-label": "search" }}
                                onChange={this.filterList}
                            />
                        </div>
                    </Toolbar>
                </AppBar>
                <Toolbar style={{ height: "103px" }} />
                <Container>{employeeList}</Container>
            </div>
        );
    }

    fetchEmployees() {
        axios.get("/api/timeregistration/GetAllEmployees").then(res => {
            const employees = res.data;
            this.setState({
                employees,
                employeesOrginalFetch: employees,
                loading: false
            });
        });
    }
}

export default withTranslation()(StaffListView);
